<div class="asset-usage-rights-container">
  <div class="header rounded-lg flex flex-row items-center sticky top-0 asset-details p-4 z-50">
    <h2 class="asset-details-title title font-bold text-xl" i18n>Usage rights</h2>
    <div class="actions text-right">
      <button *ngIf="editFlag" class="save-button pl-4 button-icon !block" mat-icon-button i18n-matTooltip matTooltip="Save" [disabled]="updateAssetForm.invalid" (click)="saveAssetInfo()">
        <mat-icon class="material-icons-outlined">save</mat-icon>
      </button>
      <button *ngIf="editFlag" class="pl-4 cursor-pointer" mat-icon-button i18n-matTooltip matTooltip="Close" (click)="editInformation()">
        <mat-icon class="material-icons-outlined">close</mat-icon>
      </button>
      <button
        *ngIf="![CustomClients.SEAT, CustomClients.VKB].includes(this.brandingKey) && !editFlag && (assetInfo.accessKeys ? (AccessAsset(assetInfo) | can: 'usagerights') : true)"
        class="cursor-pointer"
        mat-icon-button
        role="button"
        i18n-matTooltip
        matTooltip="Edit usage rights"
        (click)="editInformation()"
      >
        <mat-icon class="material-icons-outlined">edit</mat-icon>
      </button>
    </div>
  </div>
  <div class="details px-4">
    <div class="detail-header">
      <ng-template [ngIf]="CustomClients.VKB !== this.brandingKey">
        <div *ngFor="let assetObj of assetInfoObject.metadata">
          <form class="asset-info-form" [formGroup]="updateAssetForm" *ngIf="editFlag && assetObj.editable">
            <div *ngIf="assetObj.formControlName === 'owner'">
              <span class="field-label">{{ assetObj.fieldLabel }}*</span>
              <sp-mat-select-search
                class="w-full"
                [formControlName]="assetObj.formControlName"
                [dataSource]="users"
                [placeholder]="'Select owner'"
                [config]="{ search: true, required: true, requiredText: 'Owner is required' }"
                [attrDataTestId]="'asset-usage-right_select_owner'"
              ></sp-mat-select-search>
            </div>
            <div class="my-2" *ngIf="assetObj.formControlName === 'notes'">
              <div class="flex flex-row justify-between">
                <span class="field-label">{{ assetObj.fieldLabel }}</span>
              </div>
              <sp-editor
                [formControlName]="assetObj.formControlName"
                [placeholder]="assetObj.fieldLabel"
                [maxLength]="5000"
                [taggingOptions]="taggingOptions"
                (usersList)="taggedUserList($event)"
                (descriptionText)="editorDescriptionText($event)"
              ></sp-editor>
            </div>
            <div class="my-2" *ngIf="['copyright', 'country', 'provider', 'source'].includes(assetObj.formControlName)">
              <div class="flex flex-row justify-between">
                <span class="field-label">{{ assetObj.fieldLabel }}</span>
              </div>
              <mat-form-field appearance="outline" color="primary" class="w-full">
                <input type="text" [placeholder]="assetObj.fieldLabel || ''" matInput [formControlName]="assetObj.formControlName" />
              </mat-form-field>
            </div>
            <div class="flex flex-col" *ngIf="assetObj.formControlName === 'expiryDate'">
              <span class="field-label">{{ assetObj.fieldLabel }}*</span>
              <div class="flex w-full">
                <sp-date-picker formControlName="expiryDate" [dateCssClass]="'w-full'" [fieldLabel]="assetObj.fieldLabel" class="w-1/2" (selectedDate)="onDateSelection($event)"></sp-date-picker>
                <mat-checkbox class="w-full m-2" [checked]="checked" (change)="checkboxChanged($event)"><span i18n>No Expiry date</span></mat-checkbox>
              </div>
            </div>
          </form>
          <div class="" *ngIf="!editFlag || !assetObj.editable">
            <div class="flex row items-start" *ngIf="assetObj.formControlName === 'owner' && userSelected?.name">
              <span class="w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
              <div
                class="inline-block w-3/5 pl-2"
                [ngClass]="{
                  'border border-[rgba(0,0,0,.12)] rounded-lg p-2 mb-4 text-[rgba(0,0,0,.6)]': editFlag && !assetObj.editable
                }"
              >
                <span>{{ userSelected?.name || '' }}</span>
              </div>
            </div>
            <div class="flex row items-start" *ngIf="assetObj.formControlName === 'expiryDate' && assetInfo['expiryDate']">
              <span class="w-2/5 field-label pb-1">{{ assetObj.fieldLabel }}</span>
              <div
                class="inline-block w-3/5 pl-2"
                [ngClass]="{
                  'border border-[rgba(0,0,0,.12)] rounded-lg p-2 mb-4 text-[rgba(0,0,0,.6)]': editFlag && !assetObj.editable
                }"
              >
                <span *ngIf="expiryDate">
                  {{ expiryDate | spDateFormat: { isSafe: true } }}
                </span>
              </div>
            </div>
            <div class="flex row items-start" *ngIf="assetObj.formControlName === 'notes' && assetInfo['notes']">
              <span class="w-2/5 field-label pb-1">{{ assetObj.fieldLabel }}</span>
              <div
                class="inline-block w-3/5 pl-2 break-words"
                [ngClass]="{
                  'border border-[rgba(0,0,0,.12)] rounded-lg p-2 mb-4 text-[rgba(0,0,0,.6)]': editFlag && !assetObj.editable
                }"
              >
                <div class="ql-container ql-snow !bg-inherit !border-0 !min-h-[inherit]">
                  <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="updateAssetForm.controls['notes'].value"></div>
                </div>
              </div>
            </div>
            <div
              class="flex row items-start"
              *ngIf="['copyright', 'country', 'provider', 'source'].includes(assetObj.formControlName) && updateAssetForm.controls[assetObj?.formControlName || ''].value"
            >
              <span class="w-2/5 field-label pb-1">{{ assetObj.fieldLabel }}</span>
              <div
                class="inline-block w-3/5 pl-2 break-words"
                [ngClass]="{
                  'border border-[rgba(0,0,0,.12)] rounded-lg p-2 mb-4 text-[rgba(0,0,0,.6)]': editFlag && !assetObj.editable
                }"
              >
                <div class="ql-container ql-snow !bg-inherit !border-0 !min-h-[inherit]">
                  <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="updateAssetForm.controls[assetObj?.formControlName || ''].value"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
    <thehubz-custom-asset-fields [tabType]="'usageRight'" #custFieldsRef [assetInfo]="assetInfo"></thehubz-custom-asset-fields>
  </div>
</div>
<thehubz-asset-notifications [asset]="assetInfo" *ngIf="!editFlag"></thehubz-asset-notifications>
